import { FormProvider } from "react-hook-form";
import { AppDialog } from "../../../../../common/components/AppDialog/AppDialog";
import { DefaultButton } from "../../../../../common/components/button/defaultButton/DefaultButton";
import { DefaultInputField } from "../../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DefaultFormMultiSelectField } from "../../../../../common/components/forms/inputs/dropdown/DefaultFormMultiSelectField";
import { IEventHistoryItemViewModel } from "../../../../../common/models/eventHistoryItemViewModel";
import { useBulkDeleteUserEventsDialog } from "../hooks/useBulkDeleteUserEventsDialog";
import { BULK_DELETE_CONFIRMATION_WORD } from "../models/bulkDeleteUserEventsFormModel";
import styles from "./BulkDeleteUserEventsDialog.module.scss";

interface IBulkDeleteUserEventsDialogProps {
  userId?: number;
  visible: boolean;
  history?: IEventHistoryItemViewModel[];
  onHide: () => void;
}

export const BulkDeleteUserEventsDialog = ({
  userId,
  visible,
  history,
  onHide,
}: IBulkDeleteUserEventsDialogProps) => {
  const { form, eventOptions, canDelete, isLoading, handleDelete } =
    useBulkDeleteUserEventsDialog({
      userId,
      visible,
      history,
      onHide,
    });

  return (
    <AppDialog
      header="Перманентно изтриване на резервации"
      visible={visible}
      onHide={onHide}
      className={styles.dialog}
    >
      <FormProvider {...form}>
        <form className={styles.form}>
          <p className={styles.warning}>
            Тази операция е <strong>абсолютно необратима</strong>. Избраните
            резервации ще бъдат изтрити перманентно и няма да могат да бъдат
            възстановени.
          </p>

          <DefaultFormMultiSelectField
            name="userEventIds"
            label="Резервации"
            options={eventOptions}
            includeId={false}
            display="chip"
            emptyMessage="Няма налични резервации."
            filter
            width="100%"
            virtualScrollerOptions={{ itemSize: 38 }}
            optionDisabled="disabled"
          />

          <p className={styles.disclaimer}>
            Забележка: резервации, на които има вече са платени, не
            могат да бъдат изтрити оттук. Първо премахнете начина на плащане от
            детайлите на резервацията.
          </p>

          <DefaultInputField
            name="confirmationWord"
            label={`Моля изпишете думата "${BULK_DELETE_CONFIRMATION_WORD}" в полето по-долу`}
            placeholder={BULK_DELETE_CONFIRMATION_WORD}
            width="100%"
          />

          <div className={styles.footer}>
            <DefaultButton
              label="Изтрий перманентно"
              onClick={handleDelete}
              disabled={!canDelete}
              loading={isLoading}
            />
          </div>
        </form>
      </FormProvider>
    </AppDialog>
  );
};
